<div data-test-id="taetigkeit"> {{taetigkeit}} <span
		data-test-id="empfaenger">{{empfaenger}}</span></div>
@if (hasFaxEmpfaenger) {
	<div data-test-id="fax-empfaenger">und vorab per Fax an {{ faxEmpfaenger }}</div>
}
